import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { DashboardHome } from '~/features/dashboard/types/dashboard.type';

/**
 * 대시보드 홈 통합 조회
 * @description summary, realtimeActivities, systemAlerts, inquiries를 한 번에 조회
 * @endpoint GET /admin/dashboard/home
 */
export function getDashboardHomeApi() {
  return axiosInstance.get<ApiResponse<DashboardHome>>('/admin/dashboard/home');
}
